<script setup lang="ts">
import RlSearchCard from '@/components/common/RlSearchCard.vue'
import type { IDashboardShipment } from '@/types/rc/shipments'
import { computed } from 'vue'

const props = defineProps<{ shipment: IDashboardShipment }>()

// Tracking information might be undefined if the shipment is being set from the FE before the actual options BE query is resolved
const detailItems = computed(() => [
  { header: 'Tracking #', value: props.shipment.tracking_information?.tracking_number ?? 'N/A' },
  { header: 'BOL #', value: props.shipment.tracking_information?.bol_number ?? 'N/A' },
  { header: 'Waybill #', value: props.shipment.tracking_information?.waybill_number ?? 'N/A' },
])
</script>

<template>
  <rl-search-card :detail-items="detailItems">
    <template #header>
      <span>Shipment #{{ props.shipment.id }}&nbsp;</span>
      <el-tag>{{ props.shipment.type }}</el-tag>
    </template>
  </rl-search-card>
</template>
